import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './Component/Header/Header';
import Body from './Component/Body/Body';
function App() {
  
  return (
    <div className="body">
      
     <Header></Header> 
     <Body></Body>
    </div>
  );
}

export default App;
